// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__3BQ1o","subtitle":"styles_subtitle__1sOOx","contatoComercial":"styles_contatoComercial__2ALk0"};